import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import WidgetSettings from './WidgetSettings';
import { locationShape } from '../../shapes/index';

/**
 * A higher order component for getting widget settings from the context.
 */
export default function withWidgetSettingsProvider(WrappedComponent) {
  const componentName = WrappedComponent.displayName || WrappedComponent.name;
  class withWidgetSettingsProviderComponent extends React.Component {
    static propTypes = {
      location: locationShape,
    };
    render() {
      return (
        <WidgetSettings history={this.props.location} location={this.props.location}>
          <WrappedComponent {...this.props} />
        </WidgetSettings>
      );
    }
  }
  withWidgetSettingsProviderComponent.displayName = `withWidgetSettingsProvider(${componentName})`;
  withWidgetSettingsProviderComponent.WrappedComponent = WrappedComponent;
  hoistNonReactStatic(withWidgetSettingsProviderComponent, WrappedComponent);

  return withWidgetSettingsProviderComponent;
}
